///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
namespace TotalContest {
    import Controller = TotalCore.Common.Controller;
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    import ISCEService = angular.ISCEService;
    import IScope = angular.IScope;

    @Controller('controllers.totalcontest')
    export class PreviewCtrl {
        public preview = {
            screen: 'participate',
            options: {},
            submissions: [],
            layout: 'grid'
        };
        public settings = this.SettingsService.settings;

        constructor(private $scope: IScope, private $sce: ISCEService, private SettingsService: SettingsService) {

        }

        escape(content) {
            return this.$sce.trustAsHtml(content);
        }

        generateSubmissions(number) {
            this.preview.submissions = [];
            for (let index = 0; index < number; index++) {
                let submission = {
                    id: index + 1,
                    date: new Date().toDateString(),
                    views: this.randomNumber(1, 1999),
                    votes: this.randomNumber(1, 1999),
                    rate: this.randomNumber(1, 5),
                    title: this.settings.contest.submissions.title,
                    subtitle: this.settings.contest.submissions.subtitle,
                };

                for (let fragment in submission) {
                    submission.title = submission.title.replace(`{{${fragment}}}`, submission[fragment]);
                    submission.subtitle = submission.subtitle.replace(`{{${fragment}}}`, submission[fragment]);
                }

                this.preview.submissions.push(submission);
            }
        }

        getFieldClass(field) {
            return ['image', 'video', 'audio'].indexOf(field.type) == -1 ? `totalcontest-form-field-type-${field.type}` : `totalcontest-form-field-type-file totalcontest-form-field-type-media totalcontest-form-field-type-${field.type}`;
        }

        getFieldType(field) {
            return ['image', 'video', 'audio'].indexOf(field.type) == -1 ? field.type : 'file';
        }

        getLayout() {
            return this.preview.layout;
        }

        getOptionsOf(field) {
            return this.preview.options[field.uid] || [];
        }

        getScreen() {
            return this.preview.screen;
        }

        getSubmissionSubtitle(submission) {
            return this.settings.contest.submissions.subtitle;
        }

        getSubmissionTitle(submission) {
            return this.$scope.$eval(this.settings.contest.submissions.title, submission);
        }

        getSubmissionWidth() {
            return '33.33333333333333333%';
        }

        getSubmissions() {
            return this.preview.submissions;
        }

        isLayout(layout) {
            return this.preview.layout === layout;
        }

        isScreen(screen) {
            return this.preview.screen === screen;
        }

        parseOptionsOf(field) {
            this.preview.options[field.uid] = field.options.split('\n').map(function (item) {
                return {label: item.replace(/(.*?\s*:+\s*)/g, '')};
            });
        }

        randomNumber(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        }

        setLayout(layout) {
            this.preview.layout = layout;
        }

        setScreen(screen) {
            this.preview.screen = screen;
        }
    }

}